import { can } from "../helpers/permissions";

export const canPermission = {
    mounted (el, binding) {
        if (!can(binding.value)) {
            el.parentNode.removeChild(el);
        }
    },
};
